<div class="loginNewPage">
  <!-- <div >Login Page Works!</div> -->
  <div id="overlaySpinner" style="display:none;">
    <div class="spinner"></div>
    <br />
    Loading...
  </div>
  <!-- <div>
    <h2>{{ "WorkspaceName" | translate }}</h2>
    <label>
      {{ "HOME.SELECT" | translate }}
      <select #langSelect (change)="translate.use(langSelect.value)">
        <option *ngFor="let lang of translate.getLangs()" [value]="lang" [selected]="lang === translate.currentLang">
          {{ lang }}
        </option>
      </select>
    </label>
  </div> -->
  <div class="loginLeft">
    <div class="logInParts">
      <div class="row sideLoginPart">
        <div class="col col-6 col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 title">
          <img class="logo" src="./assets/images/stag_logo.png" alt="logo">
        </div>
      </div>
      <div class="sideLoginPart topSignIn">
        <div class="card  p-3 mb-2 h-100 minht100per formDiv">
          <form id="login-form" class="form-group">
            <h1 class="form-header text-color-white cursorArrow">{{ 'confirminvite' | translate }}</h1>
            <!-- <h1 class="form-header text-color-white" ng-if="confirmMsgShow == true">{{toastMsg}}</h1> -->
            <div height="16px" class="form-gap-div"></div>
            <div class="row strict">
              <div class="col col-6 col-sm-6 pr-2">
                <button type="submit" (click)="acceptInvitation()" id="login-form-submit" class="form-submit-button">
                  {{ 'acceptinvite' | translate }}</button>
              </div>
              <div class="col col-6 col-sm-6 pl-2">
                <button type="submit" routerLink="/login" id="login-form-submit" class="form-submit-button">
                  {{ 'ignoreinvite' | translate }}</button>
              </div>
            </div>
          </form>
          <div>
            <div class="text-danger">
              {{error}}
            </div>
          </div>
          <div id="snackbar">
            <div class="text-message">
              {{toastMsg}}
            </div>
          </div>
        </div>
      </div>

      <div class="sideLoginPart">
        <div class="login-footer">
          <a href="" class="form-account-options">{{ 'termsOfService' | translate }}</a>
          <span class="form-footer-dot">&nbsp;</span>
          <a href="" class="form-account-options">{{ 'privacyPolicy' | translate }}</a>
          <span class="form-footer-dot">&nbsp;</span>
          <a href="" class="form-account-options">{{ 'security' | translate }}</a>
        </div>
        <!-- <div class="row">
          <div class="col col-4 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
          </div>
          <div class="col col-4 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-align-center">
            <select #langSelect (change)="translate.use(langSelect.value);updateLanguage(langSelect.value)">
              <option *ngFor="let lang of languages" [value]="lang.short"
                [selected]="lang.short === translate.currentLang">
                {{ lang.fullform }}
              </option>
            </select>
          </div>
          <div class="col col-4 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
          </div>
        </div> -->
      </div>
    </div>
  </div>
  <div class="loginSecondPart">
    <div class="logInParts">
      <div class="loginRightSide">
        <div class="centerImage">
          <img src="../assets/images/1.png">
        </div>
      </div>
    </div>
  </div>
</div>